import { Timepicker } from '@folio/stripes/components';
import classNames from 'classnames';
import React from 'react';
import css from './hiddenErrorField.css';
export default function TimeField(_a) {
    var value = _a.value, display = _a.display, inputRef = _a.inputRef, error = _a.error, onBlur = _a.onBlur, className = _a.className, onChange = _a.onChange;
    if (!display)
        return null;
    return (React.createElement("div", { className: classNames(css.hiddenErrorFieldWrapper, className) },
        React.createElement(Timepicker, { required: true, timeZone: "UTC", value: value === null || value === void 0 ? void 0 : value[0], onChange: function (_, newValue, inputValue) {
                onChange([newValue, inputValue]);
                onBlur(); // re-perform validation
            }, onInput: onBlur, onBlur: onBlur, inputRef: inputRef, useInput: true, error: error })));
}
